import videojs from 'video.js';

const VideoComponent = videojs.getComponent('Component');

class CurrentTime extends VideoComponent {
    getCurrentTime() {
        const now = new Date();
        const hh = now.getHours();
        const mm = now.getMinutes();

        return `${hh}:${mm}`;
    }

    createEl() {
        return super.createEl('div', {
            className: 'video-top-right-current',
            innerHTML: this.getCurrentTime(),
        });
    }

    initChildren() {
        this.timer = setInterval(() => {
            this.el().innerHTML = this.getCurrentTime();
        }, 1000);
    }

    dispose() {
        clearInterval(this.timer);
    }
}

videojs.registerComponent('CurrentTime', CurrentTime);

class TopLineRightBtns extends VideoComponent {
    createEl() {
        return super.createEl('div', {
            className: 'video-top-right-btns',
        });
    }

    initChildren() {
        this.addChild('CurrentTime');
    }
}

videojs.registerComponent('TopLineRightBtns', TopLineRightBtns);

class TopVideoScale extends VideoComponent {
    constructor(player, options) {
        super(player, options);
        this.on('click', this.handleScaleChange);
    }

    createEl() {
        return super.createEl('ul', {
            className: 'video-top-scale-list',
            innerHTML: `<li data-tag="half">50%</li>
                        <li class="currentScale" data-tag="all">100%</li>
                        <li data-tag="full">满屏</li>`,
        });
    }

    handleScaleChange(e) {
        const selectedScale = e.target;
        const selectedScaleKey = e.target.getAttribute('data-tag');

        for (const itemScale of this.el().children) {
            itemScale.classList.remove('currentScale');
        }

        selectedScale.classList.add('currentScale');

        switch (selectedScaleKey) {
            case 'half':
                this.player_.removeClass('video-half-width');
                this.player_.removeClass('video-full-width');
                this.player_.addClass('video-half-width');
                break;
            case 'all':
                this.player_.removeClass('video-half-width');
                this.player_.removeClass('video-full-width');
                this.player_.addClass('video-full-width');
                break;
            case 'full':
                this.player_.removeClass('video-half-width');
                this.player_.removeClass('video-full-width');
                this.player_.addClass('video-full-width');
                break;
            default:
                this.player_.removeClass('video-half-width');
                this.player_.removeClass('video-full-width');
                this.player_.addClass('video-full-width');
                break;
        }
    }
}

videojs.registerComponent('TopVideoScale', TopVideoScale);

class TopLineTitle extends VideoComponent {
    constructor(player, options) {
        super(player, options);
        if (options && options.title) {
            this.el().innerHTML = options.title;
        }
    }
    createEl() {
        return super.createEl('div', {
            className: 'video-top-title',
        });
    }
}

videojs.registerComponent('TopLineTitle', TopLineTitle);

class TopContentLine extends VideoComponent {
    createEl() {
        return super.createEl('div', {
            className: 'video-top-content',
        });
    }

    initChildren() {
        const { title = '' } = this.player_.options_;

        this.addChild('TopLineTitle', { title });

        this.addChild('TopVideoScale');

        this.addChild('TopLineRightBtns');
    }
}

videojs.registerComponent('TopContentLine', TopContentLine);

/**
 * 全屏标题栏
 */
class FullScreenTitle extends VideoComponent {
    createEl() {
        return super.createEl('div', {
            className: 'video-top-line',
        });
    }

    initChildren() {
        this.addChild('TopContentLine');
    }
}

videojs.registerComponent('FullScreenTitle', FullScreenTitle);
